{
  "sight_settings": {
    "eye_to_sight": 1020,
    "arrow_to_eye": 110,
    "vertical_tpi": 24,
    "horizontal_tpi": 32,
    "sight_scale": 10,
    "clicks_per_turn": 20,
    "sight_bar_spacing": 12.7,
    "sight_bar_position": 1,
    "updated_at": null
  },
  "marks": [
    {
      "distance": 30,
      "unit": "m",
      "mark": 2,
      "sight_bar_position": 1,
      "updated_at": null
    },
    {
      "distance": 50,
      "unit": "m",
      "mark": 4.5,
      "sight_bar_position": 1,
      "updated_at": null
    },
    {
      "distance": 70,
      "unit": "m",
      "mark": 7.5,
      "sight_bar_position": 1,
      "updated_at": null
    }
  ],
  "calc": {
    "calc_v": 68.5828515229382,
    "calc_c": 0.00488908795318635,
    "calc_offset": -1.6894103675,
    "calc_fit": 0.00020379168355622035,
    "calculator_version": 2
  }
}
